import { ArrowBackIos,Search } from "@mui/icons-material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useCallback, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import useFetch from "./useFetch";
import { initDB, mySavedVideos, myWatchList } from "./ConfigureIndexDB";
import { format } from "date-fns";
import { HbrCancel } from "./newComponents/Mycustomsvgicons";


const VideoList = () => {
    const [searchVideo,setSearchVideo]=useState("");
    const [searchResults,setSearchResults]=useState("");
    const [isSerachFound,setIsSearchFound]=useState(false);
    const [filteredData, setFilteredData] = useState([]);
    const [searchAvailable,setAvailableResults]=useState(false);
    const [expandSideBar,setExpandSidebar]=useState(true);
    const [showHistory,setShowHistory]=useState(false);
    const [showSavedVideos,setShowSavedVids]=useState(false);
    const [showsidebarphone,setShowsidebarphone]=useState(false);
    const [yearInput,setYearInput]=useState("");
    const [watchedVideos,setWatchedVideos]=useState([]);
    const [savedVideos,setSavedVideos]=useState([]);
    const [clicked,setClicked]=useState(false);
    const navigate = useNavigate();
    const {data:videoMessages,ispending,erroralert} = useFetch(`${process.env.REACT_APP_VIDEOS}`);


    const divs = [];
    for(let i=0; i<100; i++){
        divs.push(
            <div className="preloader" key={i}>
                <div className="preloaderimgclone"></div>
              <div className="preloadertxtclone"><h3 style={{color:"#f1356d"}}>HBR</h3> </div>  
             </div>
        )
    };
    const videoQuery =(e)=>{
        e.preventDefault();
            if(videoMessages){
                let result = videoMessages.filter(videoData =>
                    videoData.title.replace(/[^\w\s]|_/g, '').toLowerCase().includes(searchVideo.toLowerCase())
                  );
                  if(result.length > 0){
                    setFilteredData(result);
                    setAvailableResults(true);
                    setIsSearchFound(true);
                  }else{
                    setSearchResults(`No video match for ${searchVideo}. Video may either be unavailable or try checking for any spelling or grammatical errors`);
                    setAvailableResults(true);
                    setIsSearchFound(false);
                  }
        };
    };

    const home =()=>{
        setSearchVideo("");
        setAvailableResults(false);
        setIsSearchFound(false);
        setShowSavedVids(false);
        setClicked(true);
    };

    const getSpecifiedWatchList =useCallback((e)=>{
        e.preventDefault();
        initDB().then(()=>{
            myWatchList(yearInput).then((data)=>{
                if(data){
                    setWatchedVideos(data);
                }
            }).catch((error)=>{
                console.log(error);
            });
        }).catch((error)=>{
        
        });
    },[yearInput]);

    const getSavedVideos=()=>{
        setClicked(true);
        initDB().then(()=>{
            mySavedVideos().then((data)=>{
                setSavedVideos(data);
            }).then(()=>{
                setShowSavedVids(true);
            }).catch((error)=>{
                console.log(error);
            });
        }).catch((error)=>{
            console.log(error);
        });
    };
    const goToFeedbackPage=()=>{
        navigate("/contact");
    };

    const handleShowHistory=(e)=>{
        setShowHistory(true);
        setYearInput(format(new Date(),"yyyy"));
        getSpecifiedWatchList(e);
    }

    
    return ( 
        <div className="videolist">
            {erroralert && <div>{erroralert}</div>}
             {ispending &&
             <div className='flex-column2' style={{position:"fixed",top:"30%",left:"40%",zIndex:"1"}}> 
             <div style={{
                 width:"80px",
                 height:"80px",
                 border: "5px solid white",
                 borderTop: "5px solid #eb268f",
                 borderBottom: "5px solid Teal",
                 borderRadius: "50%",
                 animation: "spin2 2s linear infinite",
             
                 }}>
                 
             </div>
         </div>
            }           
          
            <div className="videopagetop">
                <svg onClick={() => setExpandSidebar(!expandSideBar)}
                    id="video_menu_svg"
                    viewBox="0 0 24 24"
                    fill="#000000">
                    <path d="M4 6h16v2H4zm0 5h16v2H4zm0 5h16v2H4z"/>
                </svg>
                <svg 
                onClick={() => setShowsidebarphone(true)}
                    id="video_menu_svg2"
                    viewBox="0 0 24 24"
                    fill="#000000">
                    <path d="M4 6h16v2H4zm0 5h16v2H4zm0 5h16v2H4z"/>
                </svg>
                {!showSavedVideos && 
                         <div className="searchvideomessages">
                         {searchAvailable && <button id="backarrow" onClick={home}><ArrowBackIcon/></button>}
                         <form onSubmit={videoQuery}>
                         <input type="search" placeholder="search" value={searchVideo} onChange={e => setSearchVideo(e.target.value)}/>
                          </form> 
                          <button id="search_btn" onClick={videoQuery}><Search/></button> 
                        </div>
                }
                <div className="videotoplargescreen">
                {!showSavedVideos ?
                    <h4 
                    style={{
                    color: "black",
                    fontWeight: "bold" 
                  }}
                   >Messages <span style={{color:"orangered"}}>{videoMessages && videoMessages.length}</span>
                   </h4> 
                   :
                   <h4 
                   style={{
                   color: "black",
                   fontWeight: "bold" 
                 }}
                  >Saved Videos <span style={{color:"orangered"}}>{savedVideos && savedVideos.length}</span>
                  </h4> 
                }
                </div>
         

                <div className="videotopphone">
                    {!showSavedVideos ?
                        <h4 
                        style={{
                        color: "orangered",
                        fontWeight: "bold" 
                    }}
                    >{videoMessages && videoMessages.length}
                    </h4> 
                    :
                    <h4 
                    style={{
                    color: "orangered",
                    fontWeight: "bold" 
                    }}
                    >{savedVideos && savedVideos.length}
                    </h4> 
                    }
                </div>
          
            </div>
            

            <div className="videobody">
                <div className={`videosidebar ${expandSideBar ?'show':'hide'}`}>
                    <nav className="sidebarnav">
                        <div className={`sidebaritems ${clicked?'clicked':'notclicked'}`} onClick={home}>
                        <svg
                        viewBox="0 0 24 24"
                        height="30px"
                        width="30px">
                        <path d="M5 22h14a2 2 0 002-2v-9a1 1 0 00-.29-.71l-8-8a1 1 0 00-1.41 0l-8 8A1 1 0 003 11v9a2 2 0 002 2zm5-2v-5h4v5zm-5-8.59l7-7 7 7V20h-3v-5a2 2 0 00-2-2h-4a2 2 0 00-2 2v5H5z" />
                        </svg>
                        <h4>Home</h4>  
                        </div>

                        <div className={`sidebaritems`} onClick={getSavedVideos}>
                        <svg
                            viewBox="0 0 24 24"
                            height="30px"
                            width="30px">
                            <path fill="none" d="M0 0h24v24H0z" />
                            <path d="M14 10H3v2h11v-2zm0-4H3v2h11V6zm4 8v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zM3 16h7v-2H3v2z" />
                         </svg>
                         <h4>Saved Videos</h4>  
                        </div>

                        <div className={`sidebaritems`} onClick={(e)=>handleShowHistory(e)}>
                        <svg 
                            viewBox="0 0 24 24"
                        
                            height="30px"
                            width="30px">
                            <path fill="none" d="M0 0h24v24H0z" />
                            <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" />
                            <path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z" />
                        </svg>
                        <h4>Watch History</h4>
                        </div>

                        <div className={`sidebaritems`} onClick={goToFeedbackPage}>
                        <svg
                            viewBox="0 0 20 20"
                            height="30px"
                            width="30px">
                            <path fill="none" d="M0 0h20v20H0z" />
                            <path d="M12 8l-1-1H7V5.85c.29-.18.5-.48.5-.85 0-.55-.45-1-1-1s-1 .45-1 1c0 .37.21.67.5.85V16h1v-3h3l1 1h4V8h-3zm2 5h-2.59l-1-1H7V8h3.59l1 1H14v4z" />
                        </svg>
                        <h4>feedback</h4>
                        </div>
                    </nav>
                   {expandSideBar&& !showsidebarphone && <button id="closesidebar" onClick={()=>setExpandSidebar(false)}><ArrowBackIos/></button>} 
                </div>

                <div className="videodatacomp flex-row2">
                    {ispending && divs}
                    {!showSavedVideos && searchAvailable && !isSerachFound && <h3>{searchResults}</h3>}

                    {!showSavedVideos && searchAvailable && isSerachFound &&
                    filteredData.map((videoData) => (
                        <div className="videoMessageContainer" key={videoData.id}>
                          <Link className="videoMessageContainer2" to={`/horemow_video_hbr/${videoData.title}/${videoData.id}`}>
                            <img src={videoData.image} alt="video thumbnail"/>
                            <div className="vidtitle_id">
                              <h3>HBR {videoData.id}</h3>
                              <h3>{videoData.title}</h3>
                            </div>
                            <svg
                            width="2.5em"
                            height="2.5em"
                            viewBox="0 0 24 24"
                            fill="white">
                            <path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z" />
                            <path d="M9 17l8-5-8-5z" />
                            </svg>
                          </Link>
                        </div>
                      ))}
                    {!showSavedVideos && !searchAvailable && videoMessages && videoMessages.map((videoData) => (
                        <div className="videoMessageContainer" key={videoData.id}>
                        <Link className="videoMessageContainer2" to={`/horemow_video_hbr/${videoData.title}/${videoData.id}`}>
                            <img src={videoData.image} alt="video thumbnail"/>
                            <div className="vidtitle_id">
                                <h3>HBR {videoData.id}</h3>
                                <h3>{videoData.title}</h3>
                            </div>
                            <svg
                            width="2.5em"
                            height="2.5em"
                            viewBox="0 0 24 24"
                            fill="white">
                            <path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z" />
                            <path d="M9 17l8-5-8-5z" />
                            </svg>
                        </Link>
                        </div>
                    ))
                    }

                    {showSavedVideos && savedVideos && savedVideos.map((savedVids)=>(
                                <div className="videoMessageContainer" key={savedVids.id}>
                                <Link className="videoMessageContainer2" to={`/horemow_video_hbr/${savedVids.vidTitle}/${savedVids.id}`}>
                                    <img src={savedVids.vidImage} alt="video thumbnail"/>
                                    <div className="vidtitle_id">
                                        <h3>HBR {savedVids.id}</h3>
                                        <h3>{savedVids.vidTitle}</h3>
                                    </div>

                                    <svg
                                    width="2.5em"
                                    height="2.5em"
                                    viewBox="0 0 24 24"
                                    fill="white">
                                    <path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z" />
                                    <path d="M9 17l8-5-8-5z" />
                                    </svg>
                                </Link>
                                </div>
                    ))}

                    {showHistory && 
                        <div className="historylab">
                            <div className="videopagetop2 flex-spacebetween">
                            <div className="searchvideomessages">
                            <form onSubmit={getSpecifiedWatchList}>
                                <input type="text" placeholder="year of assignment" value={yearInput} onChange={e => setYearInput(e.target.value.trim())}/>
                                <button onClick={getSpecifiedWatchList}
                                    style={{
                                        padding:"8px",
                                        border:"none",
                                        backgroundColor:"#0b6b93",
                                        color:"white",
                                        borderRadius:"10px"
                                    }}>
                                    Query
                                </button> 
                            </form>
                           
                            </div>
                            <h4>Watched Messages: {watchedVideos && watchedVideos.length}</h4>
                            <HbrCancel width="2em" height="2em" fillColour="black" handleClick={()=>setShowHistory(false)}/>
                            </div>

                            <div className="videodatacomp flex-row2">
                                {watchedVideos && watchedVideos.map((data)=>(
                                    <div className="videoMessageContainer2" key={data.id}>
                                        <img src={data.vidImage} alt="video thumbnail"/>
                                        <div className="vidtitle_id">
                                            <h3>HBR {data.id}</h3>
                                            <h3>{data.vidTitle}</h3>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    }

                </div> 
            </div>
            <div className={`videosidebarphone ${showsidebarphone ?'show':'hide'}`}>
                    <nav className="sidebarnavphone">
                        <div className={`sidebaritems`} onClick={home}>
                        <svg
                        viewBox="0 0 24 24"
                        height="30px"
                        width="30px">
                        <path d="M5 22h14a2 2 0 002-2v-9a1 1 0 00-.29-.71l-8-8a1 1 0 00-1.41 0l-8 8A1 1 0 003 11v9a2 2 0 002 2zm5-2v-5h4v5zm-5-8.59l7-7 7 7V20h-3v-5a2 2 0 00-2-2h-4a2 2 0 00-2 2v5H5z" />
                        </svg>
                        <h4>Home</h4>  
                        </div>

                        <div className={`sidebaritems`} onClick={getSavedVideos}>
                        <svg
                            viewBox="0 0 24 24"
                            height="30px"
                            width="30px">
                            <path fill="none" d="M0 0h24v24H0z" />
                            <path d="M14 10H3v2h11v-2zm0-4H3v2h11V6zm4 8v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zM3 16h7v-2H3v2z" />
                         </svg>
                         <h4>Saved Videos</h4>  
                        </div>

                        <div className={`sidebaritems`} onClick={(e)=>handleShowHistory(e)}>
                        <svg 
                            viewBox="0 0 24 24"
                        
                            height="30px"
                            width="30px">
                            <path fill="none" d="M0 0h24v24H0z" />
                            <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" />
                            <path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z" />
                        </svg>
                        <h4>Watch History</h4>
                        </div>

                        <div className={`sidebaritems`} onClick={goToFeedbackPage}>
                        <svg
                            viewBox="0 0 20 20"
                            height="30px"
                            width="30px">
                            <path fill="none" d="M0 0h20v20H0z" />
                            <path d="M12 8l-1-1H7V5.85c.29-.18.5-.48.5-.85 0-.55-.45-1-1-1s-1 .45-1 1c0 .37.21.67.5.85V16h1v-3h3l1 1h4V8h-3zm2 5h-2.59l-1-1H7V8h3.59l1 1H14v4z" />
                        </svg>
                        <h4>feedback</h4>
                        </div>
                    </nav>
                   {showsidebarphone && 
                   <button id="closephonevidside" onClick={()=>setShowsidebarphone(false)}>
                    <ArrowBackIos/>
                    </button>
                    } 
                </div>
        
        </div>
     );
}
export default VideoList;